const HotelSummary = ({ hotelSummary, transport, currency, styles, formatPriceWithCurrency }) => {

  return (hotelSummary.rooms.length > 0) && (
    <div className={styles.cartItem}>
      <h3>Hotel</h3>
      <div className={styles.cro1381HotelMeta} id="floating-cart-hotel-details">
        <h3 className={styles.ticketDesc}>{hotelSummary.hotel_name}</h3>
        {hotelSummary.rooms.map((room, index) => {
          return (
            <p
              className={styles.productInfo}
              key={index}
              data-testId="room-name"
              id="room-meta"
            >
              {room.qty} x {room.title}
            </p>
          );
        })}
        {(transport.carrier === '') && (
          <p className={styles.hotelTotal}>
            <span data-testid="hotel-total">
              {formatPriceWithCurrency(hotelSummary.total_hotel_price)}
            </span>
          </p>
        )}
      </div>
    </div>
  );
};

export default HotelSummary;
